// extracted by mini-css-extract-plugin
export default {"main":"styles_main__svSOv","header":"styles_header__67DAi","text":"styles_text__DsVdP"};